import { Grid } from "@material-ui/core";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { formatCountries, formatDate, formatGender } from "../../utils";
import ContentChild from "../ContentChild";

function PassportContent({ values, makeGrid = false }) {
  const { t } = useTranslation();
  const {
    idoc_birthday,
    idoc_issued_date,
    idoc_expired_date,
    idoc_number,
    idoc_surname,
    idoc_given_name,
    idoc_gender,
    idoc_nationality,
  } = values;

  const documentContents = [
    {
      label: t("customer_management.text_date_of_issue"),
      value: formatDate(idoc_issued_date),
    },
    {
      label: t("customer_management.text_surname"),
      value: idoc_surname,
    },
    {
      label: t("customer_management.text_given_name"),
      value: idoc_given_name,
    },
    {
      label: t("customer_management.text_date_of_expiry"),
      value: formatDate(idoc_expired_date),
    },
    {
      label: t("customer_management.text_date_of_birth"),
      value: formatDate(idoc_birthday),
    },
    {
      label: t("customer_management.text_passport_number"),
      value: idoc_number,
    },
    {
      label: t("customer_management.text_gender"),
      value: formatGender(idoc_gender),
    },
    {
      label: t("customer_management.text_nationality"),
      value: formatCountries(idoc_nationality),
    },
  ];

  return (
    <>
      {documentContents.map((document, index) => (
        <Fragment key={index}>
          {!makeGrid && <ContentChild label={document.label} value={document.value} />}
          {!!makeGrid && (
            <Grid item md={makeGrid}>
              <ContentChild label={document.label} value={document.value || "---"} />
            </Grid>
          )}
        </Fragment>
      ))}
    </>
  );
}

export default PassportContent;
